import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router'
import store from './store'
import PerfectScrollbar from 'vue2-perfect-scrollbar'
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'


import AppPageHeader from '@/views/layout/AppPageHeader.vue'
import AppLoader from '@/components/Loader.vue'

import { Role } from '@/helpers/role'
import { getUserRole } from '@/helpers/utilities'
import { VueReCaptcha } from 'vue-recaptcha-v3'



Vue.component('app-page-header', AppPageHeader);
Vue.component('app-loader', AppLoader);
Vue.use(PerfectScrollbar);

Vue.use(VueReCaptcha, { 
    //siteKey: '6Lc1hdcZAAAAAFlvsnMD2_-9Iz6xELJtTCd16uUn', // development - localhost sitekey
    siteKey: '6Le-i9cZAAAAAE9goG5M_MSh7WPpWB0Sr9zTZnBW', // production sitekey
    loaderOptions: {
      autoHideBadge: true
    }  
  }
);


// Some middleware to help us ensure the user is authenticated.
router.beforeEach((to, from, next) => {

  const currentUser = store.getters.user;
  const authorize  = to.meta.authorize;

  if(to.matched.some(record => record.meta.requiresAuth) && (!store.getters.user.access_token || store.getters.user.access_token === '')) {
    return next({
      path: '/prijava',
      query: { redirect: to.fullPath }
    })
  } 

  else if(authorize && authorize !== 'undefined') {
    if(authorize.length && !authorize.includes(currentUser.type)) {
      return next({
        path: '/prijava',
        query: { redirect: to.fullPath }
      })
    }

    return next()
  }

  else if ( (to.name == 'login' || to.name == 'passwordResetRequest' || to.name == 'passwordReset') && store.state.user.access_token) {
    if((getUserRole() === Role.Admin && currentUser.type === Role.Admin) || (getUserRole() === Role.Observer && currentUser.type === Role.Observer)) {
        return next({name: 'admin_dashboard'})
    }

    return next({name: 'dashboard'})
  } 
  
  else if(to.path == '/') {
    if((getUserRole() === Role.Admin && currentUser.type === Role.Admin) || (getUserRole() === Role.Observer && currentUser.type === Role.Observer)) {
      return next({name: 'admin_dashboard'})
    }

    return next({name: 'dashboard'})
  } 
  
  else {
    return next()
  }
})

// Check local storage to handle refreshes
if (window.localStorage) {
  var user = JSON.parse(window.localStorage.getItem('fl32aitqtu')) || null
  if ( (user && store.state.user.id !== user.id) && (user.access_token && store.state.user.access_token !== user.access_token) ) {
    store.commit('SET_USER', user)
  }
}

//event bus
export const EventBus = new Vue();

Vue.config.productionTip = false

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App),
}).$mount('#app')
